document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-grid--circle').forEach(function (track) {
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        track.scrollLeft += e.deltaY;
      }
    }, { passive: false });

    var isDown = false, startX = 0, scrollLeft = 0;
    track.style.cursor = 'grab';
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      track.style.cursor = 'grabbing';
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
      track.style.cursor = 'grab';
    });
    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.classList.remove('is-dragging');
      track.style.cursor = 'grab';
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.4;
      track.scrollLeft = scrollLeft - walk;
    });
  });
});
